// src/LanguageContext.js
import React, { createContext, useContext, useEffect, useState } from "react";

const SUPPORTED_LANGS = ["en", "sr", "de"];
const LanguageContext = createContext();

function getInitialLang() {
    // 1) From ?lang= in URL (coming from Django)
    const params = new URLSearchParams(window.location.search);
    let lang = params.get("lang");

    // 2) Or from localStorage (if user is already in React)
    if (!lang) {
        lang = localStorage.getItem("fl_lang");
    }

    // 3) Default fallback
    if (!lang || !SUPPORTED_LANGS.includes(lang)) {
        lang = "en";
    }

    return lang;
}

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(getInitialLang);

    // Keep it in localStorage so it stays on React side
    useEffect(() => {
        localStorage.setItem("fl_lang", lang);
    }, [lang]);

    const value = { lang, setLang };
    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    return useContext(LanguageContext);
}
